/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placedetailquicklinks3Inputs */

const en_placedetailquicklinks3 = /** @type {(inputs: Placedetailquicklinks3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick links`)
};

const de_placedetailquicklinks3 = /** @type {(inputs: Placedetailquicklinks3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellzugriff`)
};

/**
* | output |
* | --- |
* | "Quick links" |
*
* @param {Placedetailquicklinks3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placedetailquicklinks3 = /** @type {((inputs?: Placedetailquicklinks3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placedetailquicklinks3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placedetailquicklinks3(inputs)
	return de_placedetailquicklinks3(inputs)
});
export { placedetailquicklinks3 as "placeDetailQuickLinks" }